import React from "react"
import { Button } from "@mui/material"
import { alpha } from "@mui/material/styles"

export const primaryTint = (opacity) => (theme) =>
  alpha(theme.palette.primary.main, opacity)

export const outlinedActionSx = {
  textTransform: "unset",
  border: 1,
  borderColor: "grey.400",
  borderRadius: 1,
  py: 0.5,
  px: 1.75,
  gap: 0.75,
  minHeight: 0,
  fontSize: "0.75rem",
  fontWeight: 500,
  color: "text.secondary",
  "&:hover": {
    borderColor: "primary.main",
    backgroundColor: primaryTint(0.08),
    color: "primary.main"
  }
}

export const OutlinedActionButton = ({ sx, ...props }) => (
  <Button variant="outlined" sx={{ ...outlinedActionSx, ...sx }} {...props} />
)
